module.exports = __webpack_public_path__ + "img/Locations.3355e851.svg";